import React from "react";
import { Link } from "react-router-dom";
import CategorySidebar from "./CategorySidebar";

import complete_house_cleaning_img from "../../components/images/stage_01/complete_house_cleaning.png";
import electrical_img from "../../components/images/stage_01/electrical.png";
import elder_caretaker_img from "../../components/images/stage_01/elder_caretaker_R2.png";
import home_utensils_cleaning_img from "../../components/images/stage_01/home&utensils_Cleaning.png";
import special_service_img from "../../components/images/stage_01/special_service.png";
import deep_cleaning_img from "../../components/images/stage_01/deep_cleaning.png";
import packers_movers_hero_img from "../../components/images/stage_01/complete_packers_movers.png";

const fallbackImage =
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80";

// Same cross-links TransportServices.js already offered, so a visitor
// landing here isn't stuck — just redirected to Coming Soon instead of the
// live listing (TransportServices.js itself is untouched, just no longer
// wired to the /services/transport-services route — see App.js).
const extraServices = [
  { name: "Home Services",      link: "/services/instant-home-services", image: complete_house_cleaning_img },
  { name: "Technical Services", link: "/services/technical-services",    image: electrical_img },
  { name: "Caretaker Services", link: "/services/caretaker-services",    image: elder_caretaker_img },
  { name: "Kitchen & Utensil Cleaning", link: "/service/special-service/kitchen-utility-cleaning", image: home_utensils_cleaning_img },
  { name: "Special Services",   link: "/services/special-services",      image: special_service_img },
  { name: "Deep Cleaning",      link: "/service/special-service/deep-cleaning", image: deep_cleaning_img },
];

const TransportServicesComingSoon = () => {
  return (
    <div style={styles.page}>
      <div style={styles.layout}>
        <aside style={styles.sidebar}>
          <CategorySidebar />

          <div style={styles.helpCard}>
            <h4 style={styles.helpTitle}>Need Help with Transport?</h4>
            <p style={styles.helpText}>Our team can help you choose the right shifting or delivery option.</p>
            <Link to="/contact-us" style={{ ...styles.chatBtn, textDecoration: "none", display: "inline-block" }}>💬 Chat with Us</Link>
            <div style={styles.helpIcon}>🚚</div>
          </div>
        </aside>

        <main style={styles.main}>
          <div style={styles.breadcrumb}>Home &gt; Transport Services</div>

          <div style={styles.heroCard}>
            <div style={styles.heroContent}>
              <h1 style={styles.heroTitle}>Transport Services</h1>
              <p style={styles.heroText}>Reliable packers, movers and delivery support for your shifting needs</p>
              <div style={styles.heroFeatures}>
                <span style={styles.heroFeature}>Verified Professionals</span>
                <span style={styles.heroFeature}>On-time Service</span>
                <span style={styles.heroFeature}>Transparent Pricing</span>
                <span style={styles.heroFeature}>Satisfaction Guarantee</span>
              </div>
            </div>
            <img
              src={packers_movers_hero_img}
              alt="transport services"
              style={styles.heroImage}
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = fallbackImage; }}
            />
          </div>

          <div style={styles.comingSoonCard}>
            <div style={styles.comingSoonIcon}>🚚</div>
            <h3 style={styles.comingSoonTitle}>Coming Soon</h3>
            <p style={styles.comingSoonText}>
              Transport Services aren't available for booking yet — check back soon.
            </p>
          </div>

          <div style={styles.exploreSection}>
            <h3 style={styles.exploreTitle}>Explore Other Services</h3>
            <div style={styles.exploreGrid}>
              {extraServices.map((item, index) => (
                <Link key={index} to={item.link} style={styles.exploreCardLink}>
                  <div style={styles.exploreCard}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={styles.exploreImage}
                      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = fallbackImage; }}
                    />
                    <div style={styles.exploreCardBody}>
                      <h4 style={styles.exploreName}>{item.name}</h4>
                      <span style={styles.exploreLink}>Check Now →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Banner — Gold Package (membership subscription upsell, same
              pattern as OutdoorServices.js's Bronze Package banner, amber
              accent instead of indigo to read as the higher tier). */}
          <div style={styles.bannerCard}>
            <img
              src={deep_cleaning_img}
              alt="Gold Package"
              style={styles.bannerImage}
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = fallbackImage; }}
            />
            <div style={styles.bannerContent}>
              <span style={styles.bannerBadge}>Subscription Plan</span>
              <h3 style={styles.bannerTitle}>Gold Package</h3>
              <p style={styles.bannerText}>26 visits every month, 3 hrs per visit</p>
              <ul style={styles.bannerList}>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> 26 Service Visits / Month (3 hrs each)</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> 2 Partners — Flexible Slot Timings</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Choose 1, 3, 6 or 12 Month Plans</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Free Product Kit on Every Tier</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Free Rapid Post-Party/Post-Fest Service on 6+ Month Plans</li>
                <li style={styles.bannerListItem}><span style={styles.bannerCheckIcon}>✓</span> Max Discount on Services</li>
              </ul>
            </div>
            <div style={styles.bannerAction}>
              <p style={styles.saveText}>Flexible Monthly Plans</p>
              <Link to="/subscription-plans/checkout/silver-plus-package" style={styles.bookNowBtnLink}>Book Now →</Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

const styles = {
  page:             { background: "#f8fafc", minHeight: "100vh", padding: "20px", fontFamily: "Arial, sans-serif", color: "#111827" },
  layout:           { maxWidth: "1600px", margin: "0 auto", display: "grid", gridTemplateColumns: "250px 1fr", gap: "20px", alignItems: "start" },
  sidebar:          { display: "flex", flexDirection: "column", gap: "18px" },
  helpCard:         { background: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: "18px", padding: "18px", textAlign: "left" },
  helpTitle:        { margin: "0 0 8px", fontSize: "18px", fontWeight: 700 },
  helpText:         { margin: "0 0 14px", fontSize: "14px", color: "#6b7280", lineHeight: 1.6 },
  chatBtn:          { border: "none", background: "#fff", color: "#4f46e5", fontWeight: 700, borderRadius: "12px", padding: "12px 16px", cursor: "pointer" },
  helpIcon:         { fontSize: "54px", textAlign: "center", marginTop: "18px" },
  main:             { minWidth: 0 },
  breadcrumb:       { fontSize: "13px", color: "#9ca3af", marginBottom: "14px" },

  heroCard:         { display: "grid", gridTemplateColumns: "1.2fr 0.9fr", background: "#fff", border: "1px solid #e5e7eb", borderRadius: "22px", overflow: "hidden", marginBottom: "18px" },
  heroContent:      { padding: "26px" },
  heroTitle:        { margin: 0, fontSize: "42px", fontWeight: 800 },
  heroText:         { margin: "10px 0 18px", fontSize: "15px", color: "#6b7280" },
  heroFeatures:     { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "12px" },
  heroFeature:      { fontSize: "13px", color: "#4b5563", background: "#f8fafc", border: "1px solid #eef2f7", padding: "10px 12px", borderRadius: "12px", fontWeight: 600 },
  // Source photo is a near-3:2 collage, so a 3/2 box crops it only slightly
  // (unlike CorporateServices' 4/3, which would cut too much off this image).
  heroImage:        { width: "100%", aspectRatio: "3 / 2", objectFit: "cover", objectPosition: "center", display: "block" },

  comingSoonCard:   { background: "#fff", border: "1.5px dashed #e5e7eb", borderRadius: "18px", padding: "56px 24px", textAlign: "center" },
  comingSoonIcon:   { fontSize: "40px", marginBottom: "12px" },
  comingSoonTitle:  { margin: "0 0 8px", fontSize: "22px", fontWeight: 800 },
  comingSoonText:   { margin: 0, fontSize: "14px", color: "#6b7280" },

  exploreSection:   { marginTop: "32px" },
  exploreTitle:     { margin: "0 0 14px", fontSize: "24px", fontWeight: 700 },
  exploreGrid:      { display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: "12px" },
  exploreCardLink:  { textDecoration: "none", color: "inherit" },
  exploreCard:      { background: "#fff", border: "1px solid #e5e7eb", borderRadius: "16px", overflow: "hidden", textAlign: "left" },
  exploreImage:     { width: "100%", aspectRatio: "1 / 1", objectFit: "cover", display: "block", background: "#f3f4f6" },
  exploreCardBody:  { padding: "14px" },
  exploreName:      { margin: "0 0 10px", fontSize: "15px", fontWeight: 700 },
  exploreLink:      { color: "#4f46e5", fontWeight: 700, fontSize: "13px" },

  // Gold Package banner — same gradient-card pattern as OutdoorServices.js's
  // Bronze Package banner, amber instead of indigo for the higher tier.
  bannerCard:       { marginTop: "32px", background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)", borderRadius: "20px", padding: "22px", display: "grid", gridTemplateColumns: "220px 1fr auto", gap: "24px", alignItems: "center", boxShadow: "0 14px 34px rgba(217,119,6,0.3)" },
  bannerImage:      { width: "100%", aspectRatio: "4 / 3", objectFit: "cover", borderRadius: "16px", display: "block", boxShadow: "0 6px 18px rgba(0,0,0,0.25)" },
  bannerContent:    {},
  bannerBadge:      { display: "inline-block", background: "rgba(255,255,255,0.22)", color: "#fff", fontSize: "11px", fontWeight: 800, letterSpacing: "0.6px", textTransform: "uppercase", padding: "5px 12px", borderRadius: "999px", marginBottom: "10px" },
  bannerTitle:      { margin: "0 0 6px", fontSize: "26px", fontWeight: 800, color: "#fff" },
  bannerText:       { margin: "0 0 14px", fontSize: "14px", color: "rgba(255,255,255,0.9)" },
  bannerList:       { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: "8px" },
  bannerListItem:   { display: "flex", alignItems: "flex-start", gap: "8px", fontSize: "13.5px", fontWeight: 600, color: "#fff" },
  bannerCheckIcon:  { color: "#166534", fontWeight: 900, flexShrink: 0 },
  bannerAction:     { textAlign: "center" },
  saveText:         { margin: "0 0 12px", fontSize: "12px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "rgba(255,255,255,0.85)" },
  bookNowBtnLink:   { display: "inline-flex", alignItems: "center", justifyContent: "center", border: "none", background: "#fff", color: "#b45309", height: "50px", padding: "0 26px", borderRadius: "12px", fontWeight: 800, fontSize: "14.5px", cursor: "pointer", textDecoration: "none", whiteSpace: "nowrap", boxShadow: "0 6px 16px rgba(0,0,0,0.2)" },
};

export default TransportServicesComingSoon;
